import moment from 'moment'

const TokenTimingService = (moment) => {
    const service = {}

    service.getExpiresAt = (expiresIn) => {
        return moment().add(expiresIn, 's').valueOf()
    }

    service.getTimeLeft = (expiresAt) => {
        return moment(expiresAt).valueOf() - moment().valueOf()
    }

    service.now = () => {
        return moment.now()
    }

    return service
}

export default TokenTimingService(moment)
